let Vars = {
    APP_VERSION: '20190905.1',
    SIMULATED_MODE: process.env.NODE_ENV !== 'production' // MODO SIMULADO - Altere para true para usar dados mockados
};

/**
 * ENVIRONMENT
 */
let isInProdMode = window.location.href.includes('cieloecommerce') ||
    window.location.href.includes('vermont') ||
    window.location.href.includes('avalon');
if (isInProdMode)
    Vars.ENVIRONMENT = 'PRD';
else if (window.location.href.includes('sandbox'))
    Vars.ENVIRONMENT = 'SDB';
else
    Vars.ENVIRONMENT = 'DEV';

Vars.USE_SIMULATED_MODE = Vars.ENVIRONMENT == 'DEV' && Vars.SIMULATED_MODE;

/**
 * GATEWAY INFO
*/
Vars.API_GATEWAY_URL =
    Vars.ENVIRONMENT === 'DEV'
        ? '/api'             // URL em DEV
        : '/checkoutui/api'; // URL em release

Vars.GOOGLE_ANALYTICS_TRACKING_ID =
    (Vars.ENVIRONMENT === 'PRD')
        ? 'UA-147211815-2'   // Chave de produção
        : 'UA-147211815-1';  // Chave de sandbox

/**
 * CHECKOUT INFO
 */
Vars.CIELO_CHECKOUT_URL =
    (Vars.ENVIRONMENT === 'PRD')
        ? 'https://cieloecommerce.cielo.com.br'        // Produção
        : 'https://meucheckoutsandbox.braspag.com.br'; // Sandbox

/**
 * SCRIPT MPI BRSPAG
 */
Vars.MPI_SCRIPT_URL =
    (Vars.ENVIRONMENT === 'PRD')
        ? 'https://mpi.braspag.com.br/Scripts/BP.Mpi.3ds20.min.js'   // Produção
        : 'https://mpisandbox.braspag.com.br/Scripts/BP.Mpi.3ds20.min.js';  // Sandbox

Vars.ELO_VOUCHER_BIN_LIST = [
    '506722', '509023', '509105', '509030', '506720', '509007', '506774', '506739', '650525',
    '650727', '651661', '651667', '651656', '655010', '655006', '509020', '509021', '650526',
    '650047', '650928', '650971', '509022', '650915', '650955', '650947', '650919'
];

Vars.PAYMENT_NOTIFICATION_HUB_URL = (() => {
    switch (Vars.ENVIRONMENT) {
    case 'PRD':
        return 'https://checkoutstatusupdate.cieloecommerce.cielo.com.br/hubs/payment-notification';
    case 'SDB':
        return 'https://checkoutstatusupdatesandbox.cieloecommerce.cielo.com.br/hubs/payment-notification';
    case 'DEV':
        return 'https://localhost:5001/hubs/payment-notification';
    default:
        return 'https://checkoutstatusupdate.cieloecommerce.cielo.com.br/hubs/payment-notification';
    }
})();

Vars.MINUTES_TO_CLOSE_HUB_CONNECTION = 5;

Vars.DYNATRACE_SCRIPT_URL = Vars.ENVIRONMENT === 'PRD'
    ? 'https://js-cdn.dynatrace.com/jstag/19223e8e12b/bf08413vmu/cb63da978f0f672f_complete.js'
    : 'https://js-cdn.dynatrace.com/jstag/18f0de72187/bf28544xtr/461c6c23ee03bf1f_complete.js';

Vars.C2P_MASTERCARD_UI_KIT_SCRIPT_URL = 'https://src.mastercard.com/srci/integration/components/src-ui-kit/src-ui-kit.esm.js';

Vars.C2P_MASTERCARD_UI_KIT_CSS_URL = 'https://src.mastercard.com/srci/integration/components/src-ui-kit/src-ui-kit.css';

export default Vars;
